import GreenhouseStrategyPlan from './GreenhouseStrategyPlan';

export default GreenhouseStrategyPlan;
